import script from "./CertificationUpdate.vue?vue&type=script&setup=true&lang=ts"
export * from "./CertificationUpdate.vue?vue&type=script&setup=true&lang=ts"

import "@/styles/certification-updates/base.css?vue&type=style&index=0&id=f4dfcaba&scoped=true&lang=css"
import "./CertificationUpdate.vue?vue&type=style&index=1&id=f4dfcaba&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\src\\ApplicantPortal.Web\\clientapp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f4dfcaba"]])

export default __exports__